import 'magnific-popup';

const handleModal = (trigger = '.js-modal') => {
  $(trigger).magnificPopup({
    type: 'inline',
    preloader: false,
    modal: true
  });

  $(document).on('click', '.js-modal-close', function (e) {
    $.magnificPopup.close();

    e.preventDefault();
  });
}

handleModal();
